import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const searchGame = ({ lang, term }) => Http.get(`${lang}/games/search?q=${term}`)

export const getGames = (
	params = {
		per_page: 10,
		page: 1,
		'filter[term]': '',
	},
) => Http.get(`/games/fetch${serialize(params)}`)

export const destroyGame = (
	params = {
		gameSlug: null,
	},
) => Http.delete(`/games/${params.gameSlug}/destroy`)

export const saveGame = (
	params = {
		name: null,
	},
) => Http.post(`/games/store`, params)

export const updateGame = (
	params = {
		gameSlug: null,
		name: null,
	},
) => Http.put(`/games/${params.gameSlug}/update`, params)

export const showGame = (
	params = {
		gameSlug: null,
	},
) => Http.get(`/games/${params.gameSlug}/show`)

export const promoteGame = (
	params = {
		gameSlug: null,
		is_promoted: false,
		promoted_from: null,
		promoted_days: null,
	},
) => Http.post(`/games/${params.gameSlug}/promote`, params)

export const batchUpsertGamesGame = (
	params = {
		gameSlug: null,
		games_id: null,
	},
) => Http.post(`/games/batch/games/${params.gameSlug}/upsert`, params)

export const destroyGameGame = (
	params = {
		gameId: null,
	},
) => Http.delete(`/games/games/${params.gameSlug}/destroy`, { data: { game_id: params.gameId } })

export const updateGameCover = igdb_id => {
	return Http.get(`/igdb/update-game-cover?igdb_id=${igdb_id}`)
}

export const bulkUpdateGameCovers = () => {
	return Http.post(`/igdb/bulk-update-covers`)
}

export const getGameTrophies = gameId => Http.get(`/trophies/game/${gameId}`)

export const importGameTrophies = gameId => Http.post(`/trophies/admin/import-game/${gameId}`)
